import React from 'react'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import { TAG_ADDRESS_IMMERSIVE } from '../analytics/analytics.tagids.constants'
import PanoPreview from './PanoPreview'
import s from './AddressPanoPreview.less'
import { useAddressPano } from './useAddressPano'

const AddressPanoPreview = () => {
  const panoData = useAddressPano()

  if (!panoData.url) return <></>

  return (
    <div className={s.root}>
      <PanoPreview panoData={panoData} tagId={TAG_ADDRESS_IMMERSIVE} />
    </div>
  )
}

export default withEmptyFallbackErrorBoundary(AddressPanoPreview)
